import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AddEditMetaComponent } from 'src/app/modules/content/add-edit-meta/add-edit-meta.component';
import { iSiteMenuGroup, SiteMenuService } from 'src/app/site-menu/site-menu/common/services/site-menu.service';
// import { AddEditMetaComponent } from '../add-edit-meta/add-edit-meta.component';
import { PagesService } from '../pages.service';

@Component({
  selector: 'app-add-page-to-menu',
  templateUrl: './add-page-to-menu.component.html',
  styleUrls: ['./add-page-to-menu.component.css']
})
export class AddPageToMenuComponent implements OnInit {

  categoryMenus$: Observable<any[]>;
  reference: { menuCategoryId: number; menuOptions: number; menuId: number; menuGroupId: number };

  constructor(
    public pagesService: PagesService,
    public siteMenuService: SiteMenuService,
    private dialogRef: MatDialogRef<AddEditMetaComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.reference = data;
  }

  form = new FormGroup({
    menuCategoryId: new FormControl(null),
    menuGroupId: new FormControl(null),
    menuoptions: new FormControl(2),
    menuId: new FormControl(null)
  })

  ngOnInit() {
    this.form.patchValue({
      menuCategoryId: this.reference.menuCategoryId,
      menuGroupId: this.reference.menuGroupId,
      menuId: this.reference.menuId,
      menuoptions: this.reference.menuOptions
    })

    if (!this._menuCategoryId.value) {
      this.form.patchValue({ menuGroupId: null, menuId: null })
    }

    this._menuCategoryId.valueChanges
      .subscribe(
        (res) => this.form.patchValue({ menuGroupId: null, menuId: null })
      )

    this._menuGroupId.valueChanges
      .subscribe(
        (res) => this.form.patchValue({ menuId: null })
      )

    this._menuoptions.valueChanges.subscribe(
      value => {
        if (value === 1) {
          this.form.patchValue({ menuId: null });
          this.form.get('menuId').clearValidators();
          this.form.get('menuId').updateValueAndValidity()
        }
        else {
          this.form.get('menuId').setValidators([Validators.required]);
          this.form.get('menuId').updateValueAndValidity()
        }
      }
    )
  }

  getSelectedCategoryGroups(categoryId: number, groups: iSiteMenuGroup[]) {
    if (!categoryId) { return []; }
    return groups.filter(g => Number(g.categoryId) === Number(categoryId));
  }

  getGroupMenus(groupId) {
    let menuGroups: iSiteMenuGroup[];
    this.siteMenuService.MenuGroups$.pipe(take(1)).subscribe(res => menuGroups = res);

    if (!menuGroups) { return []; }
    return menuGroups.find(g => Number(g.id) === Number(groupId)).menus;
  }

  updateMenuId(value) {
    this.form.patchValue({ 'menuId': +value });
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    this.dialogRef.close(
      this.form.value
      // menuCategoryId: this._menuCategoryId.value,
      // menuGroupId: this._menuGroupId.value,
      // menuOptions: this._menuoptions.value,
      // menuId: this._menuId.value
    )
  }

  get _menuCategoryId() { return this.form.get('menuCategoryId'); }
  get _menuGroupId() { return this.form.get('menuGroupId'); }
  get _menuoptions() { return this.form.get('menuoptions'); }
  get _menuId() { return this.form.get('menuId'); }

}
